export default {
  backendApiURL: process.env.VUE_APP_BACKEND_API_URL,
  axiosHeaders: {
  },
  auth0Active: process.env.VUE_APP_AUTH0_ACTIVE,
  dateFormatUI: 'YYYY-MM-DD',
  dateFromatBE: 'YYYY-MM-DDTHH:mm:ss'
}
